import React from 'react';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import { POBREZA_CRONICA_ARGENTINA_LEGEND } from '../LayerSelectorPanel/MapLayerOptions';
import { REFERENCE_LAYERS_MIN_ZOOM } from '../../styles/mapTheme';
import ReferenceLayerRow from './ReferenceLayerRow';

const BAR_WIDTH_BY_BUCKET = {
  muy_bajo: '24%',
  bajo: '36%',
  moderado: '48%',
  alto: '60%',
  muy_alto: '76%',
  critico: '92%',
  sin_dato: '16%',
};

const PobrezaCronicaArgentinaDetail = () => (
  <div style={{
    marginTop: '10px',
    paddingTop: '10px',
    borderTop: '1px solid rgba(255,255,255,0.07)',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  }}>
    <div style={{
      fontSize: '10px',
      fontWeight: '600',
      color: 'rgba(255,255,255,0.42)',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    }}>
      Incidencia de pobreza crónica
    </div>

    <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
      {POBREZA_CRONICA_ARGENTINA_LEGEND.map(({ value, label, color }) => (
        <div key={value} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{
            width: '10px',
            height: '10px',
            borderRadius: '3px',
            backgroundColor: color,
            flexShrink: 0,
            border: '1px solid rgba(0,0,0,0.25)',
          }} />
          <span style={{
            width: '108px',
            fontSize: '11px',
            color: 'rgba(255,255,255,0.72)',
            flexShrink: 0,
            lineHeight: 1.25,
          }}>
            {label}
          </span>
          <span style={{
            flex: 1,
            height: '6px',
            borderRadius: '999px',
            backgroundColor: 'rgba(255,255,255,0.06)',
            overflow: 'hidden',
          }}>
            <span style={{
              display: 'block',
              width: BAR_WIDTH_BY_BUCKET[value],
              height: '100%',
              borderRadius: '999px',
              backgroundColor: color,
              opacity: 0.95,
            }} />
          </span>
        </div>
      ))}
    </div>
  </div>
);

const PobrezaCronicaArgentinaLayer = ({
  enabled,
  onToggle,
  disabled = false,
  mapZoom = null,
}) => (
  <ReferenceLayerRow
    icon={TimelineOutlinedIcon}
    title="Pobreza Crónica"
    sublabel="Incidencia de pobreza crónica"
    enabled={enabled}
    onToggle={onToggle}
    disabled={disabled}
    mapZoom={mapZoom}
    minZoomToView={REFERENCE_LAYERS_MIN_ZOOM.pobrezaCronicaArgentina}
    zoomHintSublabel="Acercá más el zoom"
  >
    <PobrezaCronicaArgentinaDetail />
  </ReferenceLayerRow>
);

export default PobrezaCronicaArgentinaLayer;
